import { render, staticRenderFns } from "./ThePersonalOrdersProducts.vue?vue&type=template&id=5191288a&"
import script from "./ThePersonalOrdersProducts.vue?vue&type=script&lang=js&"
export * from "./ThePersonalOrdersProducts.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalOrdersProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports